import ExitToApp from '@mui/icons-material/ExitToApp';
import { Button, Stack, Typography } from '@mui/material';
import { memo, useMemo } from 'react';
import { Menu, MenuItem, MenuItemStyles } from 'react-pro-sidebar';
import AppVersion from './AppVersion';
import { auth } from '@modules/firebase/auth';
import { getPrimaryColor, getTransparentColor } from '@modules/theme';
import { clearSelectedInterview } from '@modules/selected-interview';
import { APP_ENV } from '@modules/consts';

import { useNavigate } from 'react-router-dom';
import useIsTallScreen from '@hooks/isTallScreen';

function LogoutFooter() {
    const navigate = useNavigate();
    const isTallScreen = useIsTallScreen();

    const menuItemStyles: MenuItemStyles = useMemo(
        () => ({
            button: () => ({
                padding: isTallScreen ? '1vh 65px' : '0.5vh 50px',
                '&:hover': { backgroundColor: `${getTransparentColor(getPrimaryColor(), 0.2)}` },
            }),
        }),
        [isTallScreen],
    );

    const US_AID_Acknowledgements = useMemo(
        () => (
            <Stack
                sx={{
                    justifyContent: 'center',
                    alignItems: 'center',
                }}
            >
                {APP_ENV !== 'sabol' ? (
                    <Button
                        size="small"
                        sx={{ textTransform: 'none', opacity: 0.8 }}
                        variant="text"
                        color="secondary"
                        onClick={() => navigate('/app/acknowledgements')}
                    >
                        Acknowledgements
                    </Button>
                ) : null}
                <AppVersion />
            </Stack>
        ),
        [navigate],
    );

    const iconProps = useMemo(
        () => ({ fontSize: isTallScreen ? ('medium' as const) : ('small' as const) }),
        [isTallScreen],
    );

    const textProps = useMemo(
        () => ({ fontSize: isTallScreen ? ('1rem' as const) : ('.7rem' as const) }),
        [isTallScreen],
    );

    return (
        <>
            <Menu menuItemStyles={menuItemStyles}>
                <MenuItem
                    onClick={() => {
                        clearSelectedInterview();
                        auth().signOut();
                    }}
                    icon={<ExitToApp {...iconProps} />}
                >
                    <Typography {...textProps}>Logout</Typography>
                </MenuItem>
            </Menu>
            {US_AID_Acknowledgements}
        </>
    );
}

export default memo(LogoutFooter);
